import { createElementVNode as _createElementVNode, resolveComponent as _resolveComponent, openBlock as _openBlock, createBlock as _createBlock, createCommentVNode as _createCommentVNode, Teleport as _Teleport, createElementBlock as _createElementBlock } from "vue"

const _hoisted_1 = { class: "flex items-center flex-wrap" }

export function render(_ctx: any,_cache: any,$props: any,$setup: any,$data: any,$options: any) {
  const _component_SelectTokenModal = _resolveComponent("SelectTokenModal")!

  return (_openBlock(), _createElementBlock("div", null, [
    _createElementVNode("div", _hoisted_1, [
      _createElementVNode("div", {
        class: "flex items-center flex-wrap apr-text text-sm",
        onClick: _cache[0] || (_cache[0] = 
//@ts-ignore
(...args) => (_ctx.onClick && _ctx.onClick(...args)))
      }, " filter ")
    ]),
    (_openBlock(), _createBlock(_Teleport, { to: "#modal" }, [
      (_ctx.selectTokenModal)
        ? (_openBlock(), _createBlock(_component_SelectTokenModal, {
            key: 0,
            "excluded-tokens": _ctx.modelValue,
            onClose: _cache[1] || (_cache[1] = ($event: any) => (_ctx.selectTokenModal = false)),
            onSelect: _ctx.addToken
          }, null, 8, ["excluded-tokens", "onSelect"]))
        : _createCommentVNode("", true)
    ]))
  ]))
}